import React from "react";
import { FormattedMessage } from "react-intl";
import { FieldProps } from "react-jsonschema-form";
import styled from "styled-components";
import { messages } from "./messages";

const InfoBlock = styled.div`
  margin: -8px 0 16px;
  font-size: 13px;
  color: #6c757d;

  ul {
    margin: 4px 0 0;
    padding-left: 18px;
    list-style: disc;
  }

  li::marker {
    color: #ff6338;
  }
`;

const INFO_ITEMS = [
  messages.multiStayDisabledInfoSplitStay,
  messages.multiStayDisabledInfoMaxRooms,
  messages.multiStayDisabledInfoBundling,
  messages.multiStayDisabledInfoGroupBooking,
  messages.multiStayDisabledInfoMultipleRoomForm,
  messages.multiStayDisabledInfoAssistedBooking,
];

export default function MultiStayDisabledInfo({ formContext }: FieldProps) {
  if (formContext?.rootFormData?.allowMultiStayCart !== false) {
    return null;
  }

  return (
    <InfoBlock>
      <FormattedMessage {...messages.multiStayDisabledInfo} />
      <ul>
        {INFO_ITEMS.map(item => (
          <li key={item.id}>
            <FormattedMessage {...item} />
          </li>
        ))}
      </ul>
    </InfoBlock>
  );
}
